import React from "react";
import AccountBalance from "../../components/AccountBalance";
import TransactionList from "../../components/TransactionList";
import IncomeExpenseSummary from "../../components/IncomeExpenseSummary";
import { DarkModeProps } from "../../types/DashboardTypes";

const DashboardHome: React.FC<DarkModeProps> = ({ darkMode }) => {
  return (
    <>
      <AccountBalance darkMode={darkMode} />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-8 mt-4 md:mt-8">
        <TransactionList darkMode={darkMode} />
        <IncomeExpenseSummary darkMode={darkMode} />
      </div>
    </>
  );
};

export default DashboardHome;